var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","fill":"currentColor","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6l1.41-1.42z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }